// extracted by mini-css-extract-plugin
export default {"breadcrumbsContainer":"Solicitudes_breadcrumbsContainer__ILBbX"};